import React from 'react';

interface LoadingStep {
  message: string;
  duration?: number;
}

interface GifLoaderProps {
  title: string;
  steps?: LoadingStep[];
  currentStep?: string;
  className?: string;
}

export function GifLoader({ 
  title, 
  steps, 
  currentStep,
  className = '' 
}: GifLoaderProps) {
  return (
    <div className={`fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 ${className}`}>
      <div className="bg-white dark:bg-gray-800 rounded-xl p-4 sm:p-8 mx-4 sm:mx-0 max-w-md w-full text-center">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-2">
          {title}
        </h2>
        
        {currentStep ? (
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 animate-pulse mb-4">
            {currentStep}
          </p>
        ) : (
          steps?.map((step, index) => (
            <p key={index} className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-4">
              {step.message}
            </p>
          ))
        )}
        
        <div className="loading">
          <img src="https://media.socialness.ai/loading/unicorn.gif" alt="Loading..." />
        </div>
      </div>
    </div>
  );
}